import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import jwt from 'jsonwebtoken';
import config from '../config/setting';
import Topbar from '../topbar/topbar';
import Sidebar from '../sidebar/sidebar';
import Footer from '../footer/footer';
import { connect } from 'react-redux';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { categoryList, delCategory, getSubCategoryByCatID } from './../../redux/actions/category';
import { logoutUser } from './../../redux/actions/user';

interface CategoryProps {
  categoryList: () => void;
  delCategory: (id: number) => void;
  getSubCategoryByCatID: (id: number) => void;
  logoutUser: () => void;
  catList: any[];
  sub_category: any[];
}

interface CategoryState {
  showDiv: string;
}

class Category extends Component<CategoryProps, CategoryState> {
  constructor(props: CategoryProps) {
    super(props);
    this.state = { showDiv: '' };
  }

  componentDidMount() {
    this.props.categoryList();
  }

  validateToken = () => {
    const token = sessionStorage.token;
    if (token) {
      jwt.verify(token, config.secretKey, (err: any) => {
        if (err) {
          this.props.logoutUser();
        }
      });
    } else {
      return <Redirect to="/" />;
    }
  };

  handleDelete = (id: number) => {
    this.props.delCategory(id);
  };

  renderDeleteModal = (row: any) => (
    <div id={`deleteCat${row.id}`} className="modal fade text-left" role="dialog" aria-hidden="true">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">Delete Category</h4>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            <p>Are you sure you want to delete this category?</p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-danger" data-dismiss="modal">
              Close
            </button>
            <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={() => this.handleDelete(row.id)}>
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  renderActionButtons = (cell: any, row: any) => (
    <div>
      <a href="#" className="btn btn-outline-danger mx-2" data-toggle="modal" data-target={`#deleteCat${row.id}`} title="Delete">
        <i className="fa fa-trash"></i>
      </a>
      <Link to={`/edit-category/${row.id}`} className="btn btn-outline-primary" title="Edit">
        <i className="fa fa-edit"></i>
      </Link>
      {this.renderDeleteModal(row)}
    </div>
  );

  renderSubCategories = (cell: any, row: any) => {
    const openModal = () => this.props.getSubCategoryByCatID(row.id);
    return (
      <div>
        <button className="btn btn-outline-primary btn-sm" data-toggle="modal" data-target={`#subCategories${row.id}`} onClick={openModal}>
          Sub Categories
        </button>
        <div id={`subCategories${row.id}`} className="modal fade text-left" role="dialog" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Sub Categories</h4>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                {this.props.sub_category.length > 0 ? (
                  this.props.sub_category.map((item, index) => (
                    <div key={index}>
                      <p style={{ wordBreak: 'break-word' }}>{item.name}</p>
                      <hr />
                    </div>
                  ))
                ) : (
                  <p>No subcategories available.</p>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-danger" data-dismiss="modal">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderStatus = (cell: any) => (
    <span className={`badge p-2 ${cell === 1 ? 'badge-success' : 'badge-danger'}`}>
      {cell === 1 ? 'Active' : 'Inactive'}
    </span>
  );

  render() {
    if (!sessionStorage.token) {
      return <Redirect to="/" />;
    }

    this.validateToken();

    const options: any = {
      sizePerPage: 10,
      page: 1,
      pageStartIndex: 1,
      paginationSize: 3,
      hideSizePerPage: true,
      insertModal: () => { return <Redirect to="/add-category" /> },
      noDataText: 'Category Not Found',
    };

    return (
      <div className="page">
        <Topbar />
        <div className="page-content d-flex align-items-stretch">
          <Sidebar />
          <div className="content-inner">
            <header className="page-header py-0">
              <div className="container-fluid">
                <div className="d-flex justify-content-between py-3">
                  <h4 className="mt-2">Category Management</h4>
                </div>
              </div>
            </header>

            <section className="tables">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-lg-12 col-12">
                    <div className="card">
                      <div className="card-body text-capitalize">
                        <BootstrapTable
                          version="4"
                          data={this.props.catList}
                          search
                          pagination={this.props.catList.length > 10}
                          options={options}
                          exportCSV
                          insertRow
                          csvFileName="categories.csv"
                          hover
                        >
                          <TableHeaderColumn isKey dataField="id" width="70" dataSort>
                            #
                          </TableHeaderColumn>
                          <TableHeaderColumn
                            dataField="sub_cat_name"
                            dataFormat={this.renderSubCategories}
                            formatExtraData={this.props}
                            csvHeader="Sub Categories"
                            width="130"
                            columnTitle
                          >
                            Sub Categories
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="cat_name" csvHeader="Name" width="150" columnTitle>
                            Name
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="description" csvHeader="Description" width="200" columnTitle>
                            Description
                          </TableHeaderColumn>
                          <TableHeaderColumn
                            dataField="status"
                            dataFormat={this.renderStatus}
                            csvHeader="Status"
                            width="100"
                            columnTitle
                          >
                            Status
                          </TableHeaderColumn>
                          <TableHeaderColumn
                            dataField="action"
                            dataFormat={this.renderActionButtons}
                            export={false}
                            width="150"
                          >
                            Actions
                          </TableHeaderColumn>
                        </BootstrapTable>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <Footer />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  catList: state.category.catList,
  sub_category: state.category.sub_category,
});

const mapDispatchToProps = (dispatch: any) => ({
  categoryList: () => dispatch(categoryList()),
  delCategory: (id: number) => dispatch(delCategory(id)),
  getSubCategoryByCatID: (id: number) => dispatch(getSubCategoryByCatID(id)),
  logoutUser: () => dispatch(logoutUser()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Category);